module.exports = __webpack_public_path__ + "static/media/closed-padlock.f20fbd4c.svg";